import {Injectable} from '@angular/core';
import {ActionsResource} from "./actions-resource.service";
import {forkJoin, of} from "rxjs";
import {concatMap, map} from "rxjs/operators";
import {ActionsPerBuilding} from "./actions-per-building";
import {logAsync} from "../../../../helpers/logging";
import {BuildingDetailsService} from "../../../buildings/details/building-details.service";
import {BuildingSummary} from "../../../common/model/building-summary";
import {ActionsQuery} from "./actions-query";
import {Action} from '../../../common/model/action';

@Injectable()
export class ActionsPerBuildingService {

    constructor(
        private readonly actionsResource: ActionsResource,
        private readonly buildingService: BuildingDetailsService,
    ) {
    }

    public all(query: ActionsQuery) {
        return this.actionsResource.all(query).pipe(
            logAsync('Actions retrieved'),
            concatMap(response => response.total > 0 ? this.organizeActionsByBuilding(response.items) : of([])),
            logAsync('Fetching buildings')
        );
    }

    private organizeActionsByBuilding(actions: Action[]) {
        return this.buildingDetails(actions).pipe(
            map(buildings => this.organize(actions, buildings))
        );
    }

    private buildingDetails(actions: Action[]) {
        const buildingIds = Array.from(
            new Set(actions.map(action => action.issues[0]?.issueBuildingId))
        ).filter(Boolean);
        return forkJoin(buildingIds.map(id => this.buildingService.getBuildingSummary(parseInt(id))));
    }

    private organize(actions: Action[], buildings: BuildingSummary[]): ActionsPerBuilding {
        const actionsPerBuilding = new ActionsPerBuilding();
        buildings.forEach(building => actionsPerBuilding.add(building, actions));
        return actionsPerBuilding;
    }
}
